import { render, staticRenderFns } from "./resumenContrato.vue?vue&type=template&id=54643f5d&"
import script from "./resumenContrato.vue?vue&type=script&lang=js&"
export * from "./resumenContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports